<template>
  <div class="body">
    <div class="AmountRecycling">
      <div
        class="AmountRecycling-tops"
        v-if="$store.state.chinaMap.dataType !== 3"
      >
        <div class="AmountRecycling-num AmountRecycling-num-speace">
          <div class="AmountRecycling-nums">{{ RecyclingName }}</div>
          <div class="AmountRecycling-nums-style">
            <chart-num :scrollNum="AmountOfRecycling" />
          </div>
        </div>
        <div class="AmountRecycling-num">
          <div class="AmountRecycling-nums">{{ RecoveryName }}</div>
          <div class="AmountRecycling-nums-style">
            <chart-num :scrollNum="AmountOfRecovery" />
          </div>
        </div>
      </div>
      <data-summary-card v-else />
    </div>
  </div>
</template>

<script>
import chartNum from '@/views/ChinaMapData/components/common/chartNum.vue';
import DataSummaryCard from '@/views/ChinaMapData/components/common/DataSummaryCard.vue';
import { getStoreCount } from '@/API/chinaMapApi/chinaMapApi';
export default {
  name: 'resourceMap',
  data() {
    return {
      AmountOfRecycling: 100,
      AmountOfRecovery: 900,
      RecyclingName: '公司（家）',
      RecoveryName: '物资（吨）',
    };
  },
  components: {
    chartNum,
    DataSummaryCard,
  },
  props: {
    mapData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    resourceData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    '$store.state.chinaMap.dataType': {
      handler: function (val) {
        if (val == 1) {
          this.RecyclingName = '公司（家）';
          this.RecoveryName = '物资（吨）';
        } else {
          this.RecyclingName = '公司（家）';
          this.RecoveryName = '服务面积（亩/次）';
        }
        this.getAmount();
      },
    },
    '$store.state.chinaMap.currentlyMapAdcode': {
      handler: function (val) {
        if (val) {
          if (this.$store.state.chinaMap.dataType == 1) {
            this.RecyclingName = '仓库（家）';
            this.RecoveryName = '物资（吨）';
          } else {
            this.RecyclingName = '客户（家）';
            this.RecoveryName = '服务面积（亩/次）';
          }
        } else {
          if (this.$store.state.chinaMap.dataType == 1) {
            this.RecyclingName = '公司（家）';
            this.RecoveryName = '物资（吨）';
          } else {
            this.RecyclingName = '公司（家）';
            this.RecoveryName = '服务面积（亩/次）';
          }
        }
        this.getAmount();
      },
    },
    '$store.state.chinaMap.timeId': {
      handler: function (val) {
        this.getAmount();
      },
    },
    '$store.state.chinaMap.companyId': {
      handler: function () {
        this.getAmount();
      },
    },
  },
  mounted() {
    this.getAmount();
  },
  methods: {
    getAmount() {
      let params = {
        region: this.$store.state.chinaMap.currentlyMapAdcode,
        types: this.$store.state.chinaMap.dataType == 1 ? '1,3' : '2,3',
        subId: this.$store.state.chinaMap.timeId,
        dataType: this.$store.state.chinaMap.currentlyMapAdcode
          ? this.$store.state.chinaMap.dataType
          : '',
        companyId: this.$store.state.chinaMap.companyId,
      };
      getStoreCount(params).then((res) => {
        if (res.code === 200) {
          this.AmountOfRecycling = Number(res.data.count || 0).toFixed(3);
          this.AmountOfRecovery = Number(res.data.sum || 0).toFixed(3);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.body {
  height: fit-content;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .AmountRecycling {
    width: 875px;
    height: 106px;
    .AmountRecycling-tops {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .AmountRecycling-num {
        color: #ffffff;
        font-size: 18px;
        .AmountRecycling-nums {
          display: flex;
          font-weight: 700;
          justify-content: center;
        }
        .AmountRecycling-nums,
        .AmountRecycling-numss {
          display: flex;
          align-items: center;
        }
        .AmountRecycling-nums-style {
          margin-top: 20px;
        }
      }
      .AmountRecycling-num-speace {
        margin-right: 40px;
      }
      .AmountRecycling-num-unit {
        background: url('~@/assets/recycling/chinaMap/numBackgrounds.svg')
          no-repeat;
        background-size: cover;
        width: 50px;
        height: 60px;
        font-weight: 700;
        margin-right: 12px;
        font-size: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  #map {
    width: 100%;
    height: calc(100% - 126px);
    /deep/.maplibregl-ctrl-bottom-right {
      display: none !important;
    }
  }
}
</style>
